module.exports = __webpack_public_path__ + "static/media/brand-refresh-app-logo-new.5d3de9c9.svg";